module.exports = "/next-static/_next/static/images/addOnsForMultistreaming-38302072b6369aef4eeb72c580bf1c5d.png";